<template>
  <div id="loadCarryingCapacityAnalysis" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6
            slot="header"
            class="searchBox"
            style="justify-content: space-between; padding: 0"
          >
            차트 조회 옵션
            <div>
              <b-button
                class="resetBtn w35 py5 px0"
                style="border-radius: 5px; margin-top: 5px"
                @click="openSetting"
                :disabled="search.stid === null"
                ><i class="fas fa-cog mr0"></i
              ></b-button>
            </div>
          </h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  @input="getDeviceId(search.stid)"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>디바이스</label>
                <b-form-select
                  v-model="search.device"
                  :options="search.deviceOptions"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>시작 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.startDate"
                  :max="search.endDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>종료 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.endDate"
                  :min="search.startDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>자동 분석</label>
                <b-form-checkbox
                  style="width: 200px"
                  v-model="search.isAutoAnalysis"
                  @input="changeAutoAnalysis"
                  value="Y"
                  unchecked-value="N"
                ></b-form-checkbox>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="search.btnDisabled"
                  >조회</b-button
                >
              </div>
            </div>
            <div class="btnGrp" v-show="search.isAutoAnalysis === 'N'">
              <div class="jcse">
                <b-button
                  class="resetBtn w35 py5 px0"
                  style="border-radius: 5px; margin-top: 5px"
                  @click="changePreviousPage"
                  :disabled="pageNum <= 1"
                  ><i class="fas fa-chevron-left mr0"></i
                ></b-button>
                <span style="font-size: 25px; color: #fff"
                  >{{ pageNum }} / {{ chart.chartDataCnt }}</span
                >
                <b-button
                  class="resetBtn w35 py5 px0"
                  style="border-radius: 5px; margin-top: 5px"
                  @click="changeNextPage"
                  :disabled="pageNum >= chart.chartDataCnt"
                  ><i class="fas fa-chevron-right mr0"></i
                ></b-button>
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 chartarea">
          <b-col class="col-12">
            <div class="h62 p15 searchBox mb15 border0">
              <div style="color: #b4b7bd; font-size: 20px">
                Total(RAWE): {{ chart.raweCnt }} &nbsp;&nbsp; Pass:
                {{ chart.passCnt }} &nbsp;&nbsp; Fail: {{ chart.failCnt }}
              </div>
              <div>
                <b-button class="excelBtn" @click="excelDownload"
                  ><i class="fas fa-download"></i>다운로드</b-button
                >
              </div>
            </div>
            <b-card class="hc-sub77 border0" body-class="h-100 p20">
              <b-row class="h-50 pb10">
                <b-col class="col-4 pr10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart1 }}
                    </h6>
                    <div id="chart1" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 px5">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart2 }}
                    </h6>
                    <div id="chart2" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 pl10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart3 }}
                    </h6>
                    <div id="chart3" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="h-50 pt10">
                <b-col class="col-4 pr10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart4 }}
                    </h6>
                    <div id="chart4" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 px5">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart5 }}
                    </h6>
                    <div id="chart5" class="graph"></div>
                  </b-card>
                </b-col>
                <b-col class="col-4 pl10">
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ chart.title.chart6 }}
                    </h6>
                    <div id="chart6" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      id="loadCarryingCapacityAnalysisModal"
      title="교량 정보 설정"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <load-carrying-capacity-analysis-modal
        :stid="search.stid"
        :bridgeData="bridgeData"
        @setBridgeInfo="getBridgeInfo"
      ></load-carrying-capacity-analysis-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import LoadCarryingCapacityAnalysisModal from "./LoadCarryingCapacityAnalysisModal";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    LoadCarryingCapacityAnalysisModal,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getTreeGridApi",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
      "getCenterBus",
    ]),
  },
  watch: {
    "search.stid"() {
      if (this.search.stid) {
        this.getBridgeInfo();
      }
    },
  },
  data() {
    return {
      chartConfig: {},
      bridgeData: {
        rd: null,
        rdMm: null,
        rmf: null,
        rmfMm: null,
        sr: null,
        filterL: null,
        filterH: null,
        tl: null,
        srF: null,
        srD: null,
        kd: null,
        rf: null,
        ipre: null,
        sl: null,
      },
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        device: null,
        deviceOptions: [{ value: null, text: "선택" }],
        startDate: null,
        endDate: null,
        btnDisabled: false,
        isAutoAnalysis: "N",
      },
      pageNum: 0,
      chart: {
        chart1: {
          clearyn: true,
          data: [],
        },
        chart2: {
          clearyn: true,
          data: [],
        },
        chart3: {
          clearyn: true,
          data: [],
        },
        chart4: {
          clearyn: true,
          data: [],
        },
        chart5: {
          clearyn: false,
          data: [],
          initDataCnt: 0,
        },
        chart6: {
          clearyn: false,
          data: [],
        },
        title: {
          chart1: "트리거 데이터에서 자유진동구간 데이터 표시",
          chart2: "주파수 분석 결과",
          chart3: "자유진동 구간에서의 댐핑계산 구간 표기",
          chart4: "지수함수를 이용한 감쇠비 계산",
          chart5: "충격계수 추정",
          chart6: "내하력 이력",
        },
        totalChartData: null,
        chartDataCnt: 0,
        autoAnalysisInterval: null,
        raweCnt: 0,
        passCnt: 0,
        failCnt: 0,
      },
      LoadYn: false,
      isFirstCall: true,
    };
  },
  created() {
    this.getProjectList();
    if (this.getSelectedDataStid) {
      this.search.stid = this.getSelectedDataStid;
      this.getBridgeInfo();
    }
  },
  mounted() {
    this.search.startDate = moment().format("YYYY-MM-DD");
    this.search.endDate = moment().format("YYYY-MM-DD");
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    openSetting() {
      this.$bvModal.show("loadCarryingCapacityAnalysisModal");
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectListAll", reqBody) // HICC230608
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            const projst = {
              'PRE': '(준비중)',
              'SVC': '',
              'IDL': '(휴면)',
              'EXP': '(종료)',
            };
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname+projst[data[i].projstate],
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.getDeviceId(this.search.stid);
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getBridgeInfo() {
      let reqBody = {
        stid: this.search.stid,
        devicetype: "1",
      };
      this.$http
        .post("/loadCarryingCapacityAnalysis/getBridgeInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let bridgeInfo = res.data.data;
            this.bridgeData.rd = bridgeInfo.RD;
            this.bridgeData.rdMm = bridgeInfo.RD_MM;
            this.bridgeData.rmf = bridgeInfo.RMF;
            this.bridgeData.rmfMm = bridgeInfo.RMF_MM;
            this.bridgeData.sr = bridgeInfo.SR;
            this.bridgeData.filterL = bridgeInfo.Filter_L;
            this.bridgeData.filterH = bridgeInfo.Filter_H;
            this.bridgeData.tl = bridgeInfo.TL;
            this.bridgeData.srF = bridgeInfo.SR_F;
            this.bridgeData.srD = bridgeInfo.SR_D;
            this.bridgeData.kd = bridgeInfo.KD;
            this.bridgeData.rf = bridgeInfo.RF;
            this.bridgeData.ipre = bridgeInfo.IPRE;
            this.bridgeData.sl = bridgeInfo.SL;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceId() {
      var reqBody = {
        stid: this.search.stid,
        devicetype: "1",
      };
      this.$http
        .post("/sensor/getDeviceId", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var devlist = res.data.data;
            var options = [{ value: null, text: "선택" }];
            for (let i = 0; i < devlist.length; i++) {
              options.push({
                value: devlist[i].deviceid,
                text: devlist[i].devicename,
              });
            }
            this.search.device = null;
            this.search.deviceOptions = options;

            if (options.length > 1) {
              if (options[0].value) {
                this.search.device = options[0].value;
              } else {
                this.search.device = options[1].value;
              }
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getData() {
      if (this.search.stid === null && this.search.device === null) return;

      var deviceSplit = String(this.search.device).split("/");
      var reqBody = {
        stid: this.search.stid,
        deviceType: deviceSplit[0],
        deviceId: deviceSplit[1],
        startDate: moment(this.search.startDate).format("YYYYMMDD"),
        endDate: moment(this.search.endDate).format("YYYYMMDD"),
        rd: this.bridgeData.rd,
        rdMm: this.bridgeData.rdMm,
        rmf: this.bridgeData.rmf,
        rmfMm: this.bridgeData.rmfMm,
        sr: this.bridgeData.sr,
        filterL: this.bridgeData.filterL,
        filterH: this.bridgeData.filterH,
        tl: this.bridgeData.tl,
        srF: this.bridgeData.srF,
        srD: this.bridgeData.srD,
        kd: this.bridgeData.kd,
        rf: this.bridgeData.rf,
        ipre: this.bridgeData.ipre,
        sl: this.bridgeData.sl,
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.startDate);
      this.setSelectedDataEndDate(this.search.endDate);

      this.search.btnDisabled = true;
      this.LoadYn = true;
      this.initData();

      this.$http
        .post("/loadCarryingCapacityAnalysis/getChartData", reqBody, {
          timeout: 600000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.search.btnDisabled = false;
            this.LoadYn = false;

            if (
              res.data.data.error_msg != null &&
              res.data.data.error_msg.length > 0
            ) {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(res.data.data.error_msg, this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
              return;
            }
            let chartInfo = res.data.data.chart_info;
            this.chart.totalChartData = res.data.data.chart_data;
            this.chart.chartDataCnt = res.data.data.data_cnt;
            this.chart.raweCnt = res.data.data.rawe_cnt;
            this.chart.passCnt = res.data.data.pass_cnt;
            this.chart.failCnt = res.data.data.fail_cnt;
            if (this.chart.chartDataCnt > 0) {
              this.pageNum = 1;
            }
            for (let i = 0; i < chartInfo.length; i++) {
              let info = chartInfo[i];
              if (info.chart_no === 1) {
                this.chart.title.chart1 = info.title;
                this.chart.chart1.clearyn = info.clear;
              } else if (info.chart_no === 2) {
                this.chart.title.chart2 = info.title;
                this.chart.chart2.clearyn = info.clear;
              } else if (info.chart_no === 3) {
                this.chart.title.chart3 = info.title;
                this.chart.chart3.clearyn = info.clear;
              } else if (info.chart_no === 4) {
                this.chart.title.chart4 = info.title;
                this.chart.chart4.clearyn = info.clear;
              } else if (info.chart_no === 5) {
                this.chart.title.chart5 = info.title;
                this.chart.chart5.clearyn = info.clear;
              } else if (info.chart_no === 6) {
                this.chart.title.chart6 = info.title;
                this.chart.chart6.clearyn = info.clear;
              } else {
                this.chart.chart5.initDataCnt = info.chart5_init_data.y.length;
                for (let j = 0; j < info.chart5_init_data.y.length; j++) {
                  let x = info.chart5_init_data.x;
                  let y = info.chart5_init_data.y[j];
                  this.chart.chart5.data.push({
                    x: x,
                    y: y.data,
                    type: "scatter",
                    mode: "lines",
                    name: y.name,
                    line: { width: 1 },
                  });
                }
              }
            }
            this.showChartData();
          } else {
            this.search.btnDisabled = false;
            this.LoadYn = false;
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.search.btnDisabled = false;
          this.LoadYn = false;
          console.error(err);
        });
    },
    initData() {
      Plotly.purge("chart1");
      Plotly.purge("chart2");
      Plotly.purge("chart3");
      Plotly.purge("chart4");
      Plotly.purge("chart5");
      Plotly.purge("chart6");

      this.chart.chart1.data = [];
      this.chart.chart2.data = [];
      this.chart.chart3.data = [];
      this.chart.chart4.data = [];
      this.chart.chart5.data = [];
      this.chart.chart6.data = [];

      this.chart.chart5.initDataCnt = 0;
      this.chart.chartDataCnt = 0;
      this.chart.pageNum = 0;
      this.chart.raweCnt = 0;
      this.chart.passCnt = 0;
      this.chart.failCnt = 0;
    },
    changeAutoAnalysis() {
      if (this.search.isAutoAnalysis === "Y") {
        this.startAutoAnalysis();
      } else {
        this.endAutoAnalysis();
      }
    },
    startAutoAnalysis() {
      this.chart.autoAnalysisInterval = setInterval(() => {
        this.changeNextPage();
      }, 500);
    },
    endAutoAnalysis() {
      if (this.chart.autoAnalysisInterval !== null) {
        clearInterval(this.chart.autoAnalysisInterval);
        this.chart.autoAnalysisInterval = null;
      }
    },
    changePreviousPage() {
      this.pageNum--;
      this.showChartData();
    },
    changeNextPage() {
      if (this.pageNum < this.chart.chartDataCnt) {
        this.pageNum++;
        this.showChartData();
      }
    },
    showChartData() {
      if (this.pageNum > 0) {
        let chartData1 = this.chart.totalChartData.chart1_data;
        if (this.chart.chart1.clearyn) {
          this.chart.chart1.data = [];
          this.chart.chart1.data.push({
            x: chartData1.x[this.pageNum - 1],
            y: chartData1.y[this.pageNum - 1],
            type: "scatter",
            mode: "lines",
            line: { width: 1, color: chartData1.color },
          });
          this.chart.chart1.data.push({
            x: chartData1.x2[this.pageNum - 1],
            y: chartData1.y2[this.pageNum - 1],
            type: "scatter",
            mode: "lines",
            line: { width: 1, color: chartData1.color2 },
          });
        } else {
          if (this.chart.chart1.data.length > 0) {
            this.chart.chart1.data[0].y.push(chartData1.y[this.pageNum - 1]);
            this.chart.chart1.data[1].x.push(chartData1.x2);
            this.chart.chart1.data[1].y.push(chartData1.y2);
          } else {
            this.chart.chart1.data = [];
            this.chart.chart1.data.push({
              y: [chartData1.y[this.pageNum - 1]],
              type: "scatter",
              mode: "lines",
              line: { width: 1, color: chartData1.color },
            });
            this.chart.chart1.data.push({
              x: [chartData1.x2],
              y: [chartData1.y2],
              type: "scatter",
              mode: "lines",
              line: { width: 1, color: chartData1.color2 },
            });
          }
        }
        this.drawLineChart("chart1", this.chart.chart1.data, {
          showlegend: false,
        });

        let chartData2 = this.chart.totalChartData.chart2_data;
        if (this.chart.chart2.clearyn) {
          this.chart.chart2.data = [];
          this.chart.chart2.data.push({
            x: chartData2.x[this.pageNum - 1],
            y: chartData2.y[this.pageNum - 1],
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          });
        } else {
          if (this.chart.chart2.data.length > 0) {
            this.chart.chart2.data[0].x.push(chartData2.x[this.pageNum - 1]);
            this.chart.chart2.data[0].y.push(chartData2.y[this.pageNum - 1]);
          } else {
            this.chart.chart2.data = [];
            this.chart.chart2.data.push({
              x: [chartData2.x[this.pageNum - 1]],
              y: [chartData2.y[this.pageNum - 1]],
              type: "scatter",
              mode: "lines",
              line: { width: 1 },
            });
          }
        }
        this.drawLineChart("chart2", this.chart.chart2.data, {
          showlegend: false,
        });

        let chartData3 = this.chart.totalChartData.chart3_data;
        if (this.chart.chart3.clearyn) {
          this.chart.chart3.data = [];
          this.chart.chart3.data.push({
            y: chartData3.y[this.pageNum - 1],
            type: "scatter",
            mode: "lines",
            line: { width: 1, color: chartData3.color },
          });
          this.chart.chart3.data.push({
            y: chartData3.y2[this.pageNum - 1],
            type: "scatter",
            mode: "lines",
            line: { width: 1, color: chartData3.color2 },
          });
        } else {
          if (this.chart.chart3.data.length > 0) {
            this.chart.chart3.data[0].y.push(chartData3.y[this.pageNum - 1]);
            this.chart.chart3.data[1].y.push(chartData3.y2);
          } else {
            this.chart.chart3.data = [];
            this.chart.chart3.data.push({
              y: [chartData3.y[this.pageNum - 1]],
              type: "scatter",
              mode: "lines",
              line: { width: 1, color: chartData3.color },
            });
            this.chart.chart3.data.push({
              y: [chartData3.y2],
              type: "scatter",
              mode: "lines",
              line: { width: 1, color: chartData3.color2 },
            });
          }
        }
        this.drawLineChart("chart3", this.chart.chart3.data, {
          showlegend: false,
        });

        let chartData4 = this.chart.totalChartData.chart4_data;
        if (this.chart.chart4.clearyn) {
          this.chart.chart4.data = [];
          this.chart.chart4.data.push({
            y: chartData4.y[this.pageNum - 1],
            type: "scatter",
            mode: "lines",
            line: { width: 1, color: chartData4.color },
          });
        } else {
          if (this.chart.chart4.data.length > 0) {
            this.chart.chart4.data[0].y.push(chartData4.y[this.pageNum - 1]);
          } else {
            this.chart.chart4.data = [];
            this.chart.chart4.data.push({
              y: [chartData4.y[this.pageNum - 1]],
              type: "scatter",
              mode: "lines",
              line: { width: 1, color: chartData4.color },
            });
          }
        }
        this.drawLineChart("chart4", this.chart.chart4.data, {
          showlegend: false,
        });

        let chartData5 = this.chart.totalChartData.chart5_data;
        let chart5MarkerSizes = [];
        let chart5MarkerColors = [];
        let chart5Len = Array.isArray(chartData5.x[this.pageNum - 1])
          ? chartData5.x[this.pageNum - 1].length
          : 1;
        for (let i = 0; i < chart5Len; i++) {
          chart5MarkerSizes.push(8);
          chart5MarkerColors.push("#0000ff");
        }

        if (this.chart.chart5.clearyn) {
          if (this.chart.chart5.initDataCnt < this.chart.chart5.data.length) {
            for (
              let k = this.chart.chart5.initDataCnt - 1;
              k < this.chart.chart5.data.length;
              k++
            ) {
              this.chart.chart5.data.pop();
            }
          }
          this.chart.chart5.data.push({
            x: chartData5.x[this.pageNum - 1],
            y: chartData5.y[this.pageNum - 1],
            type: "scatter",
            mode: "markers",
            marker: {
              size: chart5MarkerSizes,
              color: chart5MarkerColors,
            },
          });
        } else {
          if (this.chart.chart5.data.length > this.chart.chart5.initDataCnt) {
            if (
              this.chart.chart5.data[this.chart.chart5.initDataCnt].x.length <
              this.pageNum
            ) {
              this.chart.chart5.data[this.chart.chart5.initDataCnt].x.push(
                chartData5.x[this.pageNum - 1]
              );
              this.chart.chart5.data[this.chart.chart5.initDataCnt].y.push(
                chartData5.y[this.pageNum - 1]
              );
              for (let k = 0; k < chart5MarkerSizes.length; k++) {
                this.chart.chart5.data[
                  this.chart.chart5.initDataCnt
                ].marker.size.push(chart5MarkerSizes[k]);
                this.chart.chart5.data[
                  this.chart.chart5.initDataCnt
                ].marker.color.push(chart5MarkerColors[k]);
              }
            } else {
              this.chart.chart5.data[this.chart.chart5.initDataCnt].x.pop();
              this.chart.chart5.data[this.chart.chart5.initDataCnt].y.pop();
              for (let k = 0; k < chart5MarkerSizes.length; k++) {
                this.chart.chart5.data[
                  this.chart.chart5.initDataCnt
                ].marker.size.pop();
                this.chart.chart5.data[
                  this.chart.chart5.initDataCnt
                ].marker.color.pop();
              }
            }
          } else {
            if (this.chart.chart5.initDataCnt < this.chart.chart5.data.length) {
              for (
                let k = this.chart.chart5.initDataCnt - 1;
                k < this.chart.chart5.data.length;
                k++
              ) {
                this.chart.chart5.data.pop();
              }
            }
            this.chart.chart5.data.push({
              x: [chartData5.x[this.pageNum - 1]],
              y: [chartData5.y[this.pageNum - 1]],
              type: "scatter",
              mode: "markers",
              marker: {
                size: chart5MarkerSizes,
                color: chart5MarkerColors,
              },
            });
          }
        }
        this.drawDualChart("chart5", this.chart.chart5.data, {
          showlegend: false,
        });

        let chartData6 = this.chart.totalChartData.chart6_data;
        let chart6MarkerSizes = [];
        let chart6MarkerColors = [];
        let chart6Len = Array.isArray(chartData6.x[this.pageNum - 1])
          ? chartData6.x[this.pageNum - 1].length
          : 1;
        for (let i = 0; i < chart6Len; i++) {
          chart6MarkerSizes.push(8);
          chart6MarkerColors.push("#0000ff");
        }
        if (this.chart.chart6.clearyn) {
          this.chart.chart6.data = [];
          this.chart.chart6.data.push({
            x: chartData6.x[this.pageNum - 1],
            y: chartData6.y[this.pageNum - 1],
            type: "scatter",
            mode: "lines+markers",
            line: { width: 1 },
            marker: {
              size: chart6MarkerSizes,
              color: chart6MarkerColors,
            },
          });
        } else {
          if (this.chart.chart6.data.length > 0) {
            if (this.chart.chart6.data[0].x.length < this.pageNum) {
              this.chart.chart6.data[0].x.push(chartData6.x[this.pageNum - 1]);
              this.chart.chart6.data[0].y.push(chartData6.y[this.pageNum - 1]);
              for (let k = 0; k < chart6MarkerSizes.length; k++) {
                this.chart.chart6.data[0].marker.size.push(
                  chart6MarkerSizes[k]
                );
                this.chart.chart6.data[0].marker.color.push(
                  chart6MarkerColors[k]
                );
              }
            } else {
              this.chart.chart6.data[0].x.pop();
              this.chart.chart6.data[0].y.pop();
              for (let k = 0; k < chart6MarkerSizes.length; k++) {
                this.chart.chart6.data[0].marker.size.pop();
                this.chart.chart6.data[0].marker.color.pop();
              }
            }
          } else {
            this.chart.chart6.data = [];
            this.chart.chart6.data.push({
              x: [chartData6.x[this.pageNum - 1]],
              y: [chartData6.y[this.pageNum - 1]],
              type: "scatter",
              mode: "lines+markers",
              line: { width: 1 },
              marker: {
                size: chart6MarkerSizes,
                color: chart6MarkerColors,
              },
            });
          }
        }
        this.drawTimeLineChart("chart6", this.chart.chart6.data, {
          showlegend: false,
        });
      }
    },
    drawLineChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    drawDualChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setDualAxisLayout(id, {
        datacnt:
          dataArr[0].x != null && dataArr[0].x.length > 0
            ? dataArr[0].x.length
            : dataArr[0].y.length,
        showxaxiscnt: 4,
        annotation: param.annotation,
      });
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          layout.yaxis2.range = [range.y2.min, range.y2.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    drawTimeLineChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setDefaultTimeLayout(id, {
        datacnt: dataArr[0].x.length,
        showxaxiscnt: 4,
        annotation: param.annotation,
      });
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    excelDownload(evt) {
      if (this.chart.chartDataCnt === 0) {
        this.setAlertTitle();
        this.$bvModal
          .msgBoxOk("데이터 조회 후 클릭해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      } else if (this.chart.chart6.data.length === 0) {
        this.setAlertTitle();
        this.$bvModal
          .msgBoxOk("데이터가 없습니다.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      this.LoadYn = true;
      let contents = [];
      contents.push({
        sheetName: this.chart.title.chart6,
        header: ["time", "data"],
        content: {
          time: this.chart.totalChartData.chart6_data.x,
          data: this.chart.totalChartData.chart6_data.y,
        },
      });
      let startDate = moment(this.search.startDate).format("YYYYMMDD");
      let endDate = moment(this.search.endDate).format("YYYYMMDD");
      var reqBody = {
        fileName:
          "내하력 분석_" +
          startDate +
          "_" +
          endDate +
          "(" +
          this.search.stid +
          ")",
        data: contents,
      };
      this.$http
        .post("/sensor/excelDownload", reqBody, { responseType: "arraybuffer" })
        .then((res) => {
          this.LoadYn = false;
          utils.getExcelFile(res, reqBody.fileName);
        })
        .catch((err) => {
          this.LoadYn = false;
          this.setAlertTitle();
          this.$bvModal
            .msgBoxOk(err, this.getAlertOptions)
            .then((value) => {})
            .catch((err) => {
              console.error(err);
            });
        });
    },
  },
};
</script>

<style lang="scss">
#loadCarryingCapacityAnalysis {
  padding: 15px;
  & .chartOptions {
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 100px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  & .searchBox {
    justify-content: space-between;
    border-radius: 5px;
    & > div:first-child {
      & > label {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }
    & .prog {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      font-size: 16px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    & .custom-checkbox {
      & > input[type="checkbox"] {
        width: 140px;
      }
      & > label {
        display: flex;
        align-items: center;
        justify-content: center;
        &.custom-control-label {
          &::before,
          &::after {
            top: 7px;
            left: -20px;
          }
        }
      }
    }
  }
  & .chartarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
  & div.ag-theme-balham.grid {
    height: calc(100% - 60px) !important;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
  .select-container {
    .vs__dropdown-toggle {
      width: 200px;
      height: 35px;
      margin-right: 0px;
    }
    .vs__search::placeholder {
      color: #b4b7bd !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/LoadCarryingCapacityAnalysis.vue